module.exports = __webpack_public_path__ + "img/bg_6.3bb86aa1.jpg";